"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Immersive3DModelContentful1Schema = void 0;
exports.Immersive3DModelContentful1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/immersive-3d-model-contentful/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Immersive3DModelContentful1",
    "description": "References to the 3rd party CMS (Contentful) that hosts our 3D models.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:immersive-3d-model-contentful:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "modelId": {
                    "type": "string",
                    "description": "Model id in the 3rd party CMS (Contentful) that hosts our 3D models."
                }
            },
            "required": [
                "modelId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9pbW1lcnNpdmUtM2QtbW9kZWwtY29udGVudGZ1bC8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGlDQUFpQyxHQUFHO0lBQy9DLEtBQUssRUFBRSxrR0FBa0c7SUFDekcsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsNkJBQTZCO0lBQ3RDLGFBQWEsRUFBRSx3RUFBd0U7SUFDdkYsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sMERBQTBEO2FBQzNEO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsc0VBQXNFO2lCQUN0RjthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLFNBQVM7YUFDVjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9